import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useDeleteTrailer(){
    const { uid } = useFirebaseAuth();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const deleteTrailer = useCallback(
        async(trailerId) => {
            if(!uid){
                setError(new Error('User not authenticated.'));
                return;
            }
            setLoading(true);
            setError(null);
            setSuccess(false);

            try{
                await API.delete(`/users/${uid}/trailer/${trailerId}`);
                setSuccess(true);
            } catch(err){
                setError(err);
            } finally {
                setLoading(false);
            }
        },
        [uid]
    );
    return { deleteTrailer, loading, error, success };
}